import { Apis } from "../../lib/Apis";

export const useProjects = () => {

    const getProjectsData = async (setOurProjectsData, id, paginationParams = {}) => {
        try {
            const response = await Apis.getOnTheBasisOfSubCategory(id, paginationParams)
            setOurProjectsData(response.data.data)
            return response.data.pagination
        } catch (error) {
            console.log(error)
        }
    }
    const addProject = async (data) => {
        try {
            const response = await Apis.addProject(data)
            return response
        } catch (error) {
            console.log(error)
            throw error
        }
    }
    const updateProject = async (id, data) => {
        try {
            const response = await Apis.updateProject(id, data)
            return response
        } catch (error) {
            console.log(error)
            throw error
        }
    }
    const deleteProject = async (id) => {
        try {
            const response = await Apis.deleteProject(id)
            return response
        } catch (error) {
            console.log(error)
            throw error
        }
    }
    const getProjectById = async (id) => {
        try {
            const response = await Apis.getProjectById(id)
            return response.data
        } catch (error) {
            console.log(error)
            throw error
        }
    }
    const getAllProjectCategories = async (setProjectCategories) => {
        try {
            const response = await Apis.getAllProjectCategories()
            setProjectCategories(response.data.projectCategories)
        } catch (error) {
            console.log(error)
        }
    }
    const getProjectByIdData = async (id, setProjectData) => {
        try {
            const response = await Apis.getProjectById(id)
            setProjectData(response.data.projects[0])
        }
        catch (error) {
            console.log(error)
            throw error
        }
    }
    const getSimilarProjectExpectAdded = async (id, setExpectAdded) => {
        try {
            const response = await Apis.getSimilarProjectExpectAdded(id)
            setExpectAdded(response.data)
            return response
        } catch (error) {
            console.log(error)
            throw error
        }
    }
    const postSimilarProject = async (data) => {
        try {
            const response = await Apis.postSimilarProject(data)
            return response
        } catch (error) {
            console.log(error)
            throw error
        }
    }
    const getAddedSimilarProject = async (id, setAddedSimilarProject) => {
        try {
            const response = await Apis.getAddedSimilarProject(id)
            setAddedSimilarProject(response.data.similarProjects)
        } catch (error) {
            console.log(error)
            throw error
        }
    }
    const deleteSimilarProject = async (id) => {
        try {
            const response = await Apis.deleteSimilarProject(id)
            return response
        } catch (error) {
            console.log(error)
            throw error
        }
    }
    const updateSimilarProjectPosition = async (id, position) => {
        try {
            const response = await Apis.updateSimilarProjectPosition(id, position)
            return response
        } catch (error) {
            console.log(error)
            throw error
        }
    }
    const getParentProjectCategories = async (setParentProjectCategories) => {
        try {
            const response = await Apis.getParentProjectCategories()
            setParentProjectCategories(response.data.data)
            return response
        } catch (error) {
            console.log(error)
        }
    }
    const addSubCategory = async (data) => {
        try {
            const response = await Apis.addSubCategory(data)
            return response
        } catch (error) {
            console.log(error)
            throw error
        }
    }
    const updateSubCategory = async (id, data) => {
        try {
            if (data instanceof FormData) {
                data.append('id', id)
                const response = await Apis.updateSubCategory(data)
                return response
            } else {
                const body = {
                    id: id,
                    ...data
                }
                const response = await Apis.updateSubCategory(body)
                return response
            }
        } catch (error) {
            console.log(error)
            throw error
        }
    }
    const getSubCategories = async (setSubCategories, paginationParams = {}) => {
        try {
            const response = await Apis.getSubCategories(paginationParams)
            setSubCategories(response.data.data)
            return response.data.pagination
        } catch (error) {
            console.log(error)
        }
    }
    const toggleProjectStatus = async (id) => {
        try {
            const response = await Apis.toggleProjectStatus(id)
            return response
        } catch (error) {
            console.log(error)
            throw error
        }
    }
    const showProjectOnHomeScreen = async (projectId, homeScreen) => {
        try {
            const data = {
                projectId,
                homeScreen: homeScreen ? 1 : 0
            };
            const response = await Apis.addProjectToHomeScreen(data);
            return response;
        } catch (error) {
            console.error("Error updating home screen status:", error);
            return error;
        }
    };
    const updateSubCategoryPosition = async (id, position) => {
        try {
            const response = await Apis.updateSubCategoryPosition(id, position);
            return response;
        } catch (error) {
            console.log(error);
            throw error;
        }
    };
    return { getProjectsData, addProject, updateProject, deleteProject, getProjectById, getAllProjectCategories, getProjectByIdData, getSimilarProjectExpectAdded, postSimilarProject, getAddedSimilarProject, deleteSimilarProject, updateSimilarProjectPosition, getParentProjectCategories, addSubCategory, updateSubCategory, getSubCategories, toggleProjectStatus, showProjectOnHomeScreen, updateSubCategoryPosition }
}